export function dateFormater(value, fmt) {
    if (value) {
        const input = new Date(value);

        const o = {
            'M+': input.getMonth() + 1, // 月份
            'd+': input.getDate(), // 日
            'h+': input.getHours(), // 小時
            'm+': input.getMinutes(), // 分
            's+': input.getSeconds(), // 秒
            'q+': Math.floor((input.getMonth() + 3) / 3), // 季度
            S: input.getMilliseconds(), // 毫秒
        };

        if (/(Y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, `${input.getFullYear()}`.substr(4 - RegExp.$1.length));
        for (const k in o) if (new RegExp(`(${k})`).test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length));
        return fmt;
    }

    return value;
}
